import { render, staticRenderFns } from "./TopComments.vue?vue&type=template&id=2dbc15ca&scoped=true"
import script from "./TopComments.vue?vue&type=script&lang=js"
export * from "./TopComments.vue?vue&type=script&lang=js"
import style0 from "./TopComments.vue?vue&type=style&index=0&id=2dbc15ca&prod&lang=scss"
import style1 from "./TopComments.vue?vue&type=style&index=1&id=2dbc15ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc15ca",
  null
  
)

export default component.exports